import React from 'react';
import extra1 from '../../../assets/Extra/extra1.jpg';
import extra2 from '../../../assets/Extra/extra2.jpg';
import extra3 from '../../../assets/Extra/extra3.jpg';
import extra4 from '../../../assets/Extra/extra4.jpg';
import item8 from '../../../assets/Items/item8.jpg';
import item9 from '../../../assets/Items/item9.jpg';
import item10 from '../../../assets/Items/item10.jpg';
import item11 from '../../../assets/Items/item11.jpg';
import item12 from '../../../assets/Items/item12.jpg';
import item13 from '../../../assets/Items/item13.jpg';
import item14 from '../../../assets/Items/item14.jpg';
import item15 from '../../../assets/Items/item15.jpg';
import item17 from '../../../assets/Items/item17.jpg';
import item18 from '../../../assets/Items/item18.jpg';
import item19 from '../../../assets/Items/item19.jpg';
import item20 from '../../../assets/Items/item20.jpg';

const Special4 = () => {
    return (
        <div className='container mx-auto mt-24'>
            

            <div className="grid grid-cols-2 gap-4 xl:grid-cols-4">
                <div className="col-span-2 ">
                    <img className='w-full border border-[#dddddd] card-shadow' src={extra3} alt="" />
                </div>
                <div className="col-span-2">
                    <img className='w-full border border-[#dddddd] card-shadow' src={extra4} alt="" />
                </div>
                <div className="col-span-2">
                    <img className='w-full border border-[#dddddd] card-shadow' src={extra1} alt="" />
                </div>
                <div className="col-span-2">
                    <img className='w-full border border-[#dddddd] card-shadow' src={extra2} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item13} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item18} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item19} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item20} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item8} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item9} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item10} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd]  card-shadow' src={item11} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item12} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item14} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd] card-shadow' src={item15} alt="" />
                </div>
                <div className="transform transition duration-1000">
                    <img className='w-full border border-[#dddddd]  card-shadow' src={item17} alt="" />
                </div>
                
            </div>
        </div>
    );
};

export default Special4;